// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style de la carte */
.cardUserRef {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .cardUserRef:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
  
  .containerUserRef {
    position: relative;
    width: 100%;
    height: 150px;
  }
  
  .circleUserRef {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: #ddd;
    border: 4px solid #a3e635;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  
  .userInfoUserRef {
    margin-left: 20px;
  }
  
  .nameUserRef {
    font-size: 1.5em;
    font-weight: bold;
    color: #212529;
  }
  
  .emailUserRef {
    color: #495057;
    margin: 5px 0;
  }
  
  .teamInfoUserRef {
    font-size: 0.9em;
    color: #6c757d;
  }
  
  .buttonUserRef {
    background: #000;
    color: #fff;
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease;
  }
  
  .buttonUserRef:hover {
    background: #333;
  }
  
  .iconsUserRef {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  
  .iconButtonUserRef {
    background: transparent;
    border: 2px solid #6c757d;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.3s ease;
  }
  
  .iconButtonUserRef:hover {
    background: #e9ecef;
    transform: scale(1.1);
  }
  `, "",{"version":3,"sources":["webpack://./src/includes/pages/admin_associate.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qDAAqD;EACvD;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB","sourcesContent":["/* Style de la carte */\n.cardUserRef {\n    display: flex;\n    align-items: center;\n    background: #f8f9fa;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .cardUserRef:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  }\n  \n  .containerUserRef {\n    position: relative;\n    width: 100%;\n    height: 150px;\n  }\n  \n  .circleUserRef {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    background: #ddd;\n    border: 4px solid #a3e635;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n  }\n  \n  .userInfoUserRef {\n    margin-left: 20px;\n  }\n  \n  .nameUserRef {\n    font-size: 1.5em;\n    font-weight: bold;\n    color: #212529;\n  }\n  \n  .emailUserRef {\n    color: #495057;\n    margin: 5px 0;\n  }\n  \n  .teamInfoUserRef {\n    font-size: 0.9em;\n    color: #6c757d;\n  }\n  \n  .buttonUserRef {\n    background: #000;\n    color: #fff;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n  }\n  \n  .buttonUserRef:hover {\n    background: #333;\n  }\n  \n  .iconsUserRef {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n  }\n  \n  .iconButtonUserRef {\n    background: transparent;\n    border: 2px solid #6c757d;\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.3s ease, transform 0.3s ease;\n  }\n  \n  .iconButtonUserRef:hover {\n    background: #e9ecef;\n    transform: scale(1.1);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
